import React from 'react';

const FractionalDetails = ({ fraction_details }) => {
    return (
        <div>
            <div className="wg-property box-overview">
                <div className="wg-title text-11 fw-6 text-color-heading">
                    Fractional Details
                </div>
                <div className="row">
                    {fraction_details && fraction_details.length > 0 ? (
                        fraction_details.map((detail, index) => (
                            <div className="wrap-box col-sm-6 col-md-4 col-lg-4 pt-4" key={index}>
                                <div className="box-icon">
                                    <div className={`icons  ${detail?.icon}`} />
                                    <div className="content">
                                        <div className="text-4 text-color-default">{detail?.label}</div>
                                        <div className="text-1 text-color-heading">{detail?.value}</div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>No fractional details available</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FractionalDetails;
